import btnNoData from '@assets/web-v3-images/btn-nodata.png';
import backgroundNoData from '@assets/web-v3-images/img-nodata.png';
import { Text } from '@radix-ui/themes';

// UI chỉ lấy nội dung
export const NoDataContent = ({ title, describe, textBtn, handleClick }) => {
	return (
		<div className='flex flex-col items-center justify-center w-full sm:w-[75%] mx-auto'>
			<img alt='no-data' src={backgroundNoData} className='h-full w-[65%] sm:w-[80%]' />
			<Text
				className="
					pt-[4%]
					text-center
					font-bold
					text-[#6B3A17]
					text-[28px]
				"
			>
				{title}
			</Text>
			<Text
				as="p"
				className="
					mt-1
					sm:mt-2
					text-center
					text-[#B56A18]
					text-[25px]
					px-4
				"
			>
				{describe}
			</Text>
			{textBtn &&
				<button className="relative w-full cursor-pointer btn-click-active max-w-[60%] sm:max-w-[70%] mt-[4%] mb-[10%] outline-none"
					onClick={handleClick}
				>
					<img
						src={btnNoData}
						className="block w-full h-auto"
						alt="Revive"
					/>
					<Text
						className="absolute inset-0 flex items-center justify-center text-[30px]  font-semibold text-white"
						style={{
							WebkitTextStroke: "2px #FF692E",
							paintOrder: "stroke fill",
						}}
					>
						{textBtn}
					</Text>
				</button>
			}
		</div>
	)
}
// UI show căn giữa full màn
export const NoData = ({ title = 'test Title', describe = 'describe', textBtn = 'test btn', handleClick }) => {
	return (
		<div
			className="flex min-h-screen flex-col items-center justify-center overflow-y-auto">
			<NoDataContent title={title} describe={describe} textBtn={textBtn} handleClick={handleClick} />
		</div >
	)
}
